module.exports = __webpack_public_path__ + "img/illust_woman_old.aaccd29d.png";